import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const internalSupportTicketMessageSchema = z.object({
  content: z
    .string({ message: 'Campo obrigatório' })
    .min(3, 'Mínimo de 3 caracteres')
    .max(2048, 'Máximo de 2048 caracteres'),
  documents: z
    .array(
      z.object({
        id: z.string(),
        file: z.custom<File>().optional(),
        fileName: z.string(),
        currentFileUrl: z.string(),
      }),
    )
    .optional(),
})

export type InternalSupportTicketMessageValidationSchema = z.infer<typeof internalSupportTicketMessageSchema>

export const internalSupportTicketResponsibleSchema = z
  .object({
    relationType: optionSchema.optional(),
  })
  .superRefine((data, ctx) => {
    if (!data.relationType?.value) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Campo obrigatório',
        path: ['relationType'],
      })
    }
  })

export type InternalSupportTicketResponsibleValidationSchema = z.infer<typeof internalSupportTicketResponsibleSchema>

export const internalSupportTicketSchema = z.intersection(
  z.object({
    reason: optionSchema,
    subject_line: z
      .string({ message: 'Campo obrigatório' })
      .min(3, 'Mínimo de 3 caracteres')
      .max(128, 'Máximo de 128 caracteres'),
  }),
  internalSupportTicketMessageSchema,
)

export type InternalSupportTicketValidationSchema = z.infer<typeof internalSupportTicketSchema>
